<template>
	<div>
		<div class="o-section u-mb-2xl">
			<div class="o-container c-filter-bar__wrap u-anim-opacity-up" data-scroll>
				<form class="c-filter-bar o-form" @submit.prevent.stop>
					<div class="c-filter-bar__item">
						<label class="o-label sr-only" for="categories">Catégories</label>
						<div class="o-select__wrap">
							<select class="o-select" id="categories" v-model="selectedCategorie">
								<option value="" disabled>Catégories</option>
								<option v-for="(cat) in categories" :value="cat.term_id">{{ cat.name }}</option>
							</select>
						</div>
					</div>
					<div class="c-filter-bar__item">
						<label class="o-label sr-only" for="lieux">Lieux</label>
						<div class="o-select__wrap">
							<select class="o-select" id="lieux" v-model="selectedLieu">
								<option value="" disabled>Lieux</option>
								<option v-for="(salle) in salles" :value="salle.term_id">{{ salle.name }}</option>
							</select>
						</div>
					</div>
					<div class="c-filter-bar__item -has-small-calendar">
						<label class="o-label sr-only" for="date">Dates</label>
						<div class="o-input__wrap o-input__date__wrap">
							<button class="o-input o-input__button o-input__date"
								@click.prevent="toggleCalendar = !toggleCalendar">Dates
							</button>
						</div>
						<Calendar v-if="toggleCalendar" :startDate="startDate"
							@select-range="(p) => $emit('selectRange', p)" @resetFilters="$emit('resetFilters')"
							@goToPrevMonth="() => $emit('goToPrevMonth')" @goToNextMonth="() => $emit('goToNextMonth')"
							@setRange="(d, hover = false) => $emit('setRange', d, hover)" />
					</div>
					<div class="c-filter-bar__item -item-mobile">
						<label class="o-label sr-only" for="search">Mots-clés</label>
						<div class="o-input__wrap">
							<input class="o-input -input-has-icon" type="text" v-model="search" placeholder="Mots-clés"
								@keyup.enter.prevent.stop @keydown.enter.prevent.stop>
							<Svg id="search" />
						</div>
					</div>
					<div class="c-filter-bar__controls">
						<button class="c-filter-bar__controls__button" @click.prevent="$emit('changeMode', 'grid')"
							:class="{ 'is-active': mode === 'grid' }">
							<span>Grille</span>
							<Svg id="grid" />
						</button>
						<button class="c-filter-bar__controls__button" @click.prevent="$emit('changeMode', 'calendar')"
							:class="{ 'is-active': mode === 'calendar' }">
							<span>Calendrier</span>
							<Svg id="calendar" />
						</button>
					</div>
				</form>
				<div class="c-filter-bar__buttons">
					<div class="c-filter-bar__button__group">
						<button class="c-filter-bar__button js-modal-filter-open"
							@click.prevent="$toggle({ target: 'html', class: 'has-modal-filter-open', focus: 'js-modal-filter-close', focusDelay: 0.6 })">
							<Svg id="settings" />
							<span>
								Recherche avancée <sup v-if="countFilters() > 0">{{ countFilters() }}</sup>
							</span>
						</button>
					</div>
					<div class="c-filter-bar__button__group">
						<button class="c-filter-bar__button" @click.prevent="$emit('changeMode', 'calendar')"
							:class="{ 'is-active': mode === 'calendar' }">
							<Svg id="calendar" />
							<span>
								Calendrier
							</span>
						</button>
						<button class="c-filter-bar__button" @click.prevent="$emit('changeMode', 'grid')"
							:class="{ 'is-active': mode === 'grid' }">
							<Svg id="grid" />
							<span>
								Grille
							</span>
						</button>
					</div>
				</div>
				<div class="c-filter-bar__filters__wrap">
					<div class="c-filter-bar__filters">
						<template v-for="(cat) in categories" :key="cat.term_id">
							<div v-if="cat.selected" class="c-filter-bar__filter">
								{{ cat.name }}
								<button @click.prevent="$emit('deselectCategorie', cat.term_id)">
									<Svg id="close-sm" />
								</button>
							</div>
						</template>
						<template v-for="(salle) in salles" :key="salle.term_id">
							<div v-if="salle.selected" class="c-filter-bar__filter">
								{{ salle.name }}
								<button @click.prevent="$emit('deselectSalle', salle.term_id)">
									<Svg id="close-sm" />
								</button>
							</div>
						</template>
						<div v-if="calendarData.startDate !== null && calendarData.endDate !== null"
							class="c-filter-bar__filter">
							{{ calendarData.startDate.toLocaleDateString('fr-FR', {
								day: '2-digit', month: '2-digit',
								year: 'numeric'
							}) }} - {{
								calendarData.endDate.toLocaleDateString('fr-FR', {
									day: '2-digit', month: '2-digit', year:
										'numeric'
								}) }}
							<button @click.prevent="$emit('resetFilters')">
								<Svg id="close-sm" />
							</button>
						</div>
					</div>
					<button v-if="countFilters() > 0" class="c-filter-bar__filter__reset"
						@click.prevent="$emit('resetFilters')">
						<Svg id="refresh" />
						Réinitialiser la recherche
					</button>
				</div>
			</div>
		</div>

		<div class="c-modal-filter js-modal-filter" data-lenis-prevent>
			<div class="c-modal-filter__bg"
				@click.prevent="$toggle({ target: 'html', class: 'has-modal-filter-open', focus: 'js-modal-filter-open' })">
			</div>
			<div class="c-modal-filter__content u-bg-color-gradient-gray-light-top-to-bottom">
				<div class="c-modal-filter__item js-modal-filter-content-1" data-modal="content">
					<div class="c-modal-filter__item__header">
						<h2 class="o-title-4">Recherche avancée</h2>
						<button class="c-modal-filter__close js-modal-filter-close"
							@click.prevent="$toggle({ target: 'html', class: 'has-modal-filter-open', focus: 'js-modal-filter-open' })">
							<Svg id="close-sm" />
							<span class="sr-only">
								Fermer l'affichage superposé
							</span>
						</button>
					</div>
					<form class="o-form c-modal-filter__item__form">
						<div class="c-filter-bar__item -item-mobile">
							<label class="o-label sr-only" for="categories1">Catégories</label>
							<div class="o-select__wrap">
								<select class="o-select" id="categories1" v-model="selectedCategorie">
									<option value="" disabled>Catégories</option>
									<option v-for="(cat) in categories" :value="cat.term_id">{{ cat.name }}</option>
								</select>
							</div>
						</div>
						<div class="c-filter-bar__item -item-mobile">
							<label class="o-label sr-only" for="lieux1">Lieux</label>
							<div class="o-select__wrap">
								<select class="o-select" id="lieux1" v-model="selectedLieu">
									<option value="" disabled>Lieux</option>
									<option v-for="(salle) in salles" :value="salle.term_id">{{ salle.name }}</option>
								</select>
							</div>
						</div>
						<div class="c-filter-bar__item -item-mobile -has-small-calendar">
							<label class="o-label sr-only" for="date">Dates</label>
							<div class="o-input__wrap o-input__date__wrap">
								<button class="o-input o-input__button o-input__date"
									@click.prevent="toggleCalendar = !toggleCalendar">Dates
								</button>
							</div>
							<Calendar v-if="toggleCalendar" :startDate="startDate"
								@select-range="(p) => $emit('selectRange', p)" @resetFilters="$emit('resetFilters')"
								@goToPrevMonth="() => $emit('goToPrevMonth')"
								@goToNextMonth="() => $emit('goToNextMonth')"
								@setRange="(d, hover = false) => $emit('setRange', d, hover)" />
						</div>
						<div class="c-filter-bar__item -item-mobile">
							<label class="o-label sr-only" for="search">Mots-clés</label>
							<div class="o-input__wrap">
								<input class="o-input -input-has-icon" type="text" placeholder="Mots-clés" value="">
								<Svg id="search" />
							</div>
						</div>
						<Btn url='' text='Voir les résultats <sup>16</sup>' classes='' icon='eye' iconClasses=''
							target='' accessibilityText='' :data='{}' type='' />
					</form>
					<div class="c-filter-bar__filters__wrap -filters-mobile">
						<div class="c-filter-bar__filters">
							<template v-for="(cat) in categories" :key="cat.term_id">
								<div v-if="cat.selected" class="c-filter-bar__filter">
									{{ cat.name }}
									<button @click.prevent="$emit('deselectCategorie', cat.term_id)">
										<Svg id="close-sm" />
									</button>
								</div>
							</template>
							<template v-for="(salle) in salles" :key="salle.term_id">
								<div v-if="salle.selected" class="c-filter-bar__filter">
									{{ salle.name }}
									<button @click.prevent="$emit('deselectSalle', salle.term_id)">
										<Svg id="close-sm" />
									</button>
								</div>
							</template>
							<div v-if="calendarData.startDate !== null && calendarData.endDate !== null"
								class="c-filter-bar__filter">
								{{ calendarData.startDate.toLocaleDateString('fr-FR', {
									day: '2-digit', month: '2-digit',
									year: 'numeric'
								}) }} - {{
									calendarData.endDate.toLocaleDateString('fr-FR', {
										day: '2-digit', month: '2-digit', year:
											'numeric'
									}) }}
								<button @click.prevent="$emit('resetFilters')">
									<Svg id="close-sm" />
								</button>
							</div>
						</div>
						<button v-if="countFilters() > 0" class="c-filter-bar__filter__reset"
							@click.prevent="$emit('resetFilters')">
							<Svg id="refresh" />
							Réinitialiser la recherche
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, watch, inject, onUnmounted, onMounted, nextTick } from 'vue';
import Svg from '@/js/components/Svg.vue';
import Btn from '@/js/components/Button.vue';
import Calendar from '@/js/components/programmation/Calendar.vue';
import { useDebouncedRef } from '@/js/utils/debounce';
const calendarData = inject('calendarData');
const props = defineProps({
	mode: {
		type: String,
		default: 'grid',
	},
	categories: {
		type: Array,
		default: () => [],
	},
	salles: {
		type: Array,
		default: () => [],
	},
	startDate: {
		type: String,
		default: null,
	},
	searchQuery: {
		type: String,
		default: '',
	},
});

const search = useDebouncedRef('', 300);
const selectedCategorie = ref('');
const selectedLieu = ref('');
const toggleCalendar = ref(false);

const emit = defineEmits(['changeMode', 'selectCategorie', 'selectSalle', 'deselectCategorie', 'deselectSalle', 'search', 'resetFilters', 'setRange', 'goToPrevMonth', 'goToNextMonth']);

watch(search, (newValue) => {
	emit('search', newValue);
});
watch(selectedCategorie, (newValue) => {
	if (newValue !== '') {
		emit('selectCategorie', newValue);
		resetSelectedCategorie();
	}
});
watch(selectedLieu, (newValue) => {
	if (newValue !== '') {
		emit('selectSalle', newValue);
		resetSelectedLieu();
	}
});

const resetSelectedCategorie = async () => {
	await nextTick();
	selectedCategorie.value = '';
}

const resetSelectedLieu = async () => {
	await nextTick();
	selectedLieu.value = '';
}

const countFilters = () => {
	let count = 0;
	props.categories.forEach((cat) => {
		if (cat.selected) count++;
	});
	props.salles.forEach((salle) => {
		if (salle.selected) count++;
	});
	if (calendarData.value.startDate !== null && calendarData.value.endDate !== null) {
		count++;
	}
	return count;
}

const checkToggle = (e) => {
	if (e.target.closest('.-has-small-calendar')) {
		// nothing	
	} else {
		toggleCalendar.value = false;
	}
}
document.addEventListener('click', checkToggle);

onUnmounted(() => {
	document.removeEventListener('click', checkToggle);
});

onMounted(() => {
	if (window.location.search.includes('recherche')) {
		const params = new URLSearchParams(window.location.search);
		const searchQuery = params.get('recherche');
		if (searchQuery) {
			search.value = searchQuery;
		}
	}
});
</script>
